import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'Guía de mensajes que generan deseo',
  image: 'https://cdn.magicpatterns.com/uploads/v4M5zJA2xiabeK9bizDKLr/BONUS_1.jpg'
}, {
  title: 'Desafío 7 días para reactivar la atracción',
  image: 'https://cdn.magicpatterns.com/uploads/tkPqgTEFWNjuYGsxjJv6sD/BONUS_2.jpg'
}, {
  title: 'Checklist: señales de que la conexión vuelve',
  image: 'https://cdn.magicpatterns.com/uploads/d9KN9pSxQZ26cc2bdqafp3/bonus_3.jpg'
}, {
  title: 'Frases y guiones para comunicar deseo',
  image: 'https://cdn.magicpatterns.com/uploads/gEwzSuuNGQ5vMJvnnUudE3/bonus_4.jpg'
}, {
  title: 'Manual de energía femenina en la atracción',
  image: 'https://cdn.magicpatterns.com/uploads/bRAxc5U8Dx4qBgg2zTfr9T/bonus_5.jpg'
}, {
  title: '10 ideas para salir de la rutina',
  image: 'https://cdn.magicpatterns.com/uploads/oiTs1UszL657XrfemVA6d1/bonus_6.jpg'
}, {
  title: '7 gestos simples que aumentan la tensión',
  image: 'https://cdn.magicpatterns.com/uploads/mD9GFuQBgTQP4mRNK68HFo/bonus_7.jpg'
}];
const bullets = ['Guía de mensajes que generan deseo', 'Ideas para salir de la rutina', 'Frases para comunicar deseo', 'Checklist emocional', 'Técnicas para recuperar conexión', 'Recursos para fortalecer la atracción', 'Bonus sorpresa'];
export function ValueStack() {
  return <section className="py-10 md:py-16 px-6" data-id="element-241">
      <div className="max-w-3xl mx-auto" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-243">
          <p className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-gold font-semibold mb-3" data-id="element-244">
            + 7 bonus de regalo
          </p>
          <h2 className="font-playfair text-[26px] md:text-4xl text-burgundy leading-tight font-light mb-3" data-id="element-245">
            Además recibís <span className="italic" data-id="element-246">gratis</span>:
          </h2>
          <div className="w-10 h-px bg-gold/60 mx-auto" data-id="element-247" />
        </motion.div>

        {/* Visual collage — compact grid of bonus covers */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-4 sm:grid-cols-7 gap-2 md:gap-3 mb-8" data-id="element-248">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.06
        }} className="aspect-[3/4] rounded-md overflow-hidden shadow-md" data-id="element-249">
              <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-250" />
            </motion.div>)}
        </motion.div>

        {/* Bullet list — quick scan */}
        <div className="max-w-md mx-auto mb-8" data-id="element-251">
          {bullets.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-center gap-3 py-2 border-b border-burgundy/10 last:border-b-0" data-id="element-252">
              <span className="text-gold text-base flex-shrink-0" data-id="element-253">✓</span>
              <span className="text-charcoal/80 text-[14px] md:text-base" data-id="element-254">
                {b}
              </span>
            </motion.div>)}
        </div>

        {/* Value pill */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-255">
          <div className="inline-block px-5 py-3 rounded-full bg-gold/15 border border-gold/40" data-id="element-256">
            <p className="text-[13px] md:text-base font-semibold text-[#C8963E]" data-id="element-257">
              Valor total:{' '}
              <span className="line-through opacity-60" data-id="element-258">$145.000</span> — Hoy{' '}
              <span className="font-bold" data-id="element-259">GRATIS</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}